// COM port (tartı) okuma — DAL api/device/comports/read; DAL ajana sorar.
// Profil ucu tarayıcı yedeği içindir (Web Serial): ajan yoksa tarayıcı portu aynı ayarlarla açar.
import { apiClient } from './http/client';
import { ENDPOINTS } from './endpoints';

export interface ComPortReadingDto {
  comPortAlias: string;
  /** Çözümlenen sayı; okunamadıysa null */
  value: number | null;
  /** Cihazdan gelen ham satır */
  raw: string | null;
  /** Ardışık eşit okuma sayısı tuttu (tartı dengelendi) */
  stable: boolean;
  readAtUtc: string;
  error: string | null;
}

/** COM profili — alanlar System.IO.Ports.SerialPort adlarıyla (Cihazlar › COM portlar). */
export interface ComPortProfileDto {
  deviceComPortId: string;
  comPortAlias: string;
  portName: string;
  baudRate: number;
  dataBits: number;
  parity: string;
  stopBits: string;
  handshake: string;
  dtrEnable: boolean;
  rtsEnable: boolean;
  readTimeout: number;
  writeTimeout: number;
  newLine: string;
  encoding: string;
  readMode: string;
  command: string | null;
  parsePattern: string | null;
  stableReadCount: number;
  stableWindowMs: number;
  active: boolean;
}

export const comPortApi = {
  read: (alias: string, timeoutMs = 3000) =>
    apiClient.get<ComPortReadingDto>(ENDPOINTS.DEVICE_COMPORT_READ, { params: { alias, timeoutMs }, octo: { expectSuccess: false } }),
  profile: (alias: string) =>
    apiClient.get<ComPortProfileDto>(ENDPOINTS.DEVICE_COMPORT_PROFILE, { params: { alias }, octo: { expectSuccess: false } }),
};
